import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Flex, Box, Text } from 'rebass/styled-components';
import { FormInput, FormTextarea } from '@getro/rombo';

export const SuccessMessageSection = ({ title, description, onUpdate }) => {
  const { errors, touched, setFieldTouched } = useFormikContext();

  return (
    <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
      <Text
        sx={{
          fontSize: '12px',
          fontWeight: '500',
          color: 'text.subtle',
          textTransform: 'uppercase',
          letterSpacing: '1px',
        }}
      >
        Success message
      </Text>
      <Box>
        <FormInput
          label="Title"
          labelExtra="Required"
          placeholder="Enter success message title"
          field={{
            name: 'successMessageTitle',
            value: title,
            onChange: (e) => onUpdate('successMessageTitle', e.target.value),
            onBlur: () => setFieldTouched('successMessageTitle', true),
          }}
          form={{
            errors: { successMessageTitle: errors.successMessageTitle },
            touched: { successMessageTitle: touched.successMessageTitle },
          }}
        />
      </Box>
      <Box>
        <Text
          sx={{
            fontSize: '14px',
            fontWeight: '500',
            color: 'text.dark',
            mb: '4px',
          }}
        >
          Description
        </Text>
        <FormTextarea
          value={description}
          onChange={(e) => onUpdate('successMessageDescription', e.target.value)}
          placeholder="Enter success message description"
          rows={4}
        />
      </Box>
    </Flex>
  );
};

SuccessMessageSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
